import { tokenTypes, tokenSubTypes } from '../Constants.js';
function handleAlias(field) {
  if (!field?.aliasLocation?.absolute) {
    return [];
  }
  const location = field.aliasLocation.absolute;
  return [{
    startIndex: location.asIndex,
    endIndex: location.asIndex + 2,
    type: tokenTypes.KEYWORD,
    subType: tokenSubTypes.AS
  }, {
    startIndex: location.aliasIndex,
    endIndex: location.aliasIndex + location.aliasLength,
    type: tokenTypes.IDENTIFIER,
    subType: tokenSubTypes.ALIAS
  }];
}
export default {
  handleAlias
};